import styled from 'styled-components';

export const ComboSlotOptionWrapper = styled.div`
  background-color: ${Styles.color.white};
  border: 0;
  border-radius: ${Styles.borderRadius};
  box-sizing: border-box;
  box-shadow: ${Styles.boxShadow};
  color: ${Styles.color.black};
  display: flex;
  flex-direction: column;
  margin: 0 0 0.5rem 0;
  outline: ${Styles.color.tertiary};
  overflow: hidden; // fixes image border radius bug
`;

export const ComboSlotOptionLabel = styled.label`
  display: flex;
  font-size: 0.9375rem;
  justify-content: space-between;
  line-height: 1.75rem;
  padding: 0;
  position: relative;
  text-align: left;
  min-height: 5rem;
`;

export const ComboSelectionDetails = styled.div`
  border-top: 1px solid ${Styles.color.grey.four};
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3rem;
  padding: 0 1rem;
  width: 100%;
`;

export const ImageContainer = styled.div`
  font-size: 0;
  margin: 0;
  height: 80px;
  width: 106px;
  padding: 0;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 1rem;
`;

export const ComboSelectionPrice = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.9375rem;
  font-family: ${Styles.fontFamily.body};
  color: ${(p: { extraCharge?: boolean }) => (p.extraCharge ? '#e10000' : Styles.color.grey.two)};
`;
